import * as z from "zod";

const billingProvider = z.enum(["shopify", "stripe"]);

const emailAddress = z.object({
  email: z.string(),
  displayName: z.string().nullable(),
});

const dnsRecordKind = z.enum([
  "dkim",
  "spf",
  "dmarc",
  "mail_from_mx",
  "mail_from_spf",
]);
const dnsRecordStatus = z.enum([
  "ok",
  "missing",
  "misconfigured",
  "error",
  "not_applicable",
]);
const dkimStatus = z.enum(["not_started", "pending", "verified", "failed"]);

// Per-team DNS detail, surfaced as a tooltip in the SE dashboard. Null when
// the team has no email domain linked.
const dnsDetail = z.object({
  domain: z.string(),
  dkimStatus,
  records: z.array(z.object({ kind: dnsRecordKind, status: dnsRecordStatus })),
});

const emailSms = z.object({
  billingStartEmail: z.string().nullable(),
  billingStartSms: z.string().nullable(),
  emailBillingProvider: billingProvider.nullable(),
  smsBillingProvider: billingProvider.nullable(),
  emailBillingEnabled: z.boolean(),
  smsBillingEnabled: z.boolean(),
  emailBillingAccepted: z.boolean(),
  smsBillingAccepted: z.boolean(),
  phoneProvisioned: z.boolean(),
  dnsVerified: z.boolean(),
  dnsDetail: dnsDetail.nullable(),
  fromAddress: emailAddress.nullable(),
  replyToAddress: emailAddress.nullable(),
  adminSetupComplete: z.boolean(),
  welcomeFlowActive: z.boolean(),
  warmingCampaignsSent: z.number(),
  segmentsImported: z.boolean(),
});

const recover = z.object({
  billingStart: z.string().nullable(),
  billingProvider: billingProvider.nullable(),
  billingEnabled: z.boolean(),
  billingAccepted: z.boolean(),
  useSharedNumber: z.boolean().nullable(),
  phoneVerified: z.boolean(),
  recoverEnabled: z.boolean(),
  lastSendAt: z.string().nullable(),
  lastConversionAt: z.string().nullable(),
  isActiveDealButNotSending: z.boolean(),
  aiKnowledgeArticles: z.boolean(),
});

const orderTracking = z.object({
  billingStart: z.string().nullable(),
  billingProvider: billingProvider.nullable(),
  billingEnabled: z.boolean(),
  billingAccepted: z.boolean(),
  flowEnabled: z.boolean(),
  smsEnabled: z.boolean(),
  emailConfigured: z.boolean(),
});

const merchantRow = z.object({
  teamId: z.string(),
  name: z.string(),
  hubspotDealStage: z.string().nullable(),
  seOwnerName: z.string().nullable(),
  // Earliest HubSpot deal close date across the merchant's products. Drives
  // the dashboard's default "newest first" sort. ISO 8601 string or null.
  dealCloseDate: z.string().nullable(),
  emailSms: emailSms.nullable(),
  recover: recover.nullable(),
  orderTracking: orderTracking.nullable(),
});

export const getSeDashboard = {
  name: "getSeDashboard" as const,
  input: z.object({}),
  output: z.object({ merchants: z.array(merchantRow) }),
};
